export const humidityList = [
    {
        key: 'humidity1',
        label: 'humidity1',
        value: 0
    }
]